import type { FaireProductEntity } from "../../entity_types/product";

export const p_56gsj9wwdx: FaireProductEntity = {
  token: "p_56gsj9wwdx",
  type: "product",
  name: "2oz Blue Tansy & Frankincense Whipped Bison Tallow Balm",
  brandToken: "b_3bx0gt904o",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/40ac17b7d1cd3b071d51ffcaa64610cb7fa2b97899d8fea0109a203ba62c17b9.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/332a10cc82e26163bb44e2dcbaa033d2659b993f9b4195f00201bbb2cadf8812.png",
    "https://cdn.faire.com/fastly/9e5b21bbdacbe3581d8ae86aa7adf7cf5680f03c4e101166a1c939cbcc305140.png",
    "https://cdn.faire.com/fastly/620466cbf2c3b4aa01f3b3896e8af603d74a1f3cae570e2266161e1566639f00.png",
  ],
  priceDollars: 15.25,
  description:
    "Our brand new, Blue Tansy &amp; Frankincense Whipped Bison Tallow Balm is a highly requested product that is currently all the rage! We use grass-fed bison tallow because it closely mimics the skins natural oils, making it a super gentle, vitamin rich skin care option. It is deeply moisturizing but won't clog the pores.&nbsp;\n\nOur blend of blue tansy &amp; frankincense oils blend to make this balm smell incredible and adds more skin-loving benefits. These oils are wonderful for their anti-aging properties. Our whipped balm is designed for the face, but can be used from head to toe!\n\nThis tallow balm comes in a 2oz glass jar and is light blue from the blue tansy. ",
  tags: [],
  msrpDollars: 30.49,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:27:29.262Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
